import { createAction, props } from '@ngrx/store';
import { Vehicle } from '../models/main.models';

// Load Employees
export const loadVehicles = createAction('[Vehicle] Load Vehicles', props<{organizationId: string, clientId: string }>());
export const loadVehiclesSuccess = createAction('[Vehicle] Load Vehicles Success', props<{ vehicles: Vehicle[] }>());
